import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    api.googleSession(m[1])
      .then(r => {
        setUser(r.user);
        const dest = r.user?.phone_verified ? "/account" : "/verify-phone";
        nav(dest, { state: { user: r.user } });
      })
      .catch(() => nav("/login"));
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-transparent flex items-center justify-center text-[#3A3A3A]">
      Signing you in…
    </div>
  );
}
